var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 50C9.5 52.7614 11.7386 55 14.5 55H42.5C45.2614 55 47.5 52.7614 47.5 50V12H9.5V50Z",
    fill: "#E9FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7C17.5 4.23858 19.7386 2 22.5 2H38.5C41.2614 2 43.5 4.23858 43.5 7V13H17.5V7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6C15.5 3.23858 17.7386 1 20.5 1H36.5C39.2614 1 41.5 3.23858 41.5 6V12H15.5V6Z",
    fill: "#6EE4D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12H8.05556H36.5",
    stroke: "#0E4C54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 12L42.7222 12L52.5 12",
    stroke: "#0E4C54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 30V49.6C47.5 51.0322 46.9281 52.4057 45.91 53.4184C44.892 54.4311 43.5112 55 42.0714 55H14.9286C13.4888 55 12.108 54.4311 11.09 53.4184C10.0719 52.4057 9.5 51.0322 9.5 49.6V12M15.5 12V6.4C15.5 4.96783 16.0719 3.59432 17.09 2.58162C18.108 1.56893 19.4888 1 20.9286 1H36.0714C37.5112 1 38.892 1.56893 39.91 2.58162C40.9281 3.59432 41.5 4.96783 41.5 6.4V12",
    stroke: "#0E4C54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 24L18.5 43",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24L38.5 43",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 24L28.5 43",
    stroke: "#0E4C54",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 26,
    r: 1,
    fill: "#0E4C54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 22,
    r: 1,
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalIcon);
export default __webpack_public_path__ + "static/media/delete-modal-icon.8ec87d67728328154b6de0155ae4c8fb.svg";
export { ForwardRef as ReactComponent };